"use client"

import type { ReactNode } from "react"

type TdfRadioProps = {
  checked: boolean
  label: ReactNode
  onChange: () => void
}

export const TdfRadio = ({ checked, label, onChange }: TdfRadioProps) => {
  return (
    <label className="tdf-option">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="tdf-option-mark" aria-hidden="true" />
      <span className="tdf-option-label">{label}</span>
    </label>
  )
}
